export default __webpack_public_path__ + "static/media/tvoc.acbc8086.svg";